// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3VNUU","name":"Header_name__22vmz","birthday":"Header_birthday__3fEk-","skeleton":"Header_skeleton__Yc-yH"};